export default __webpack_public_path__ + "static/media/default-theme-icon.a66a6829.svg";